import { Injectable, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoadingDialogComponent } from '@amwager/feature';

@Injectable({
  providedIn: 'root',
})
export class LoadingDialogService {
  private dialogRef: MatDialogRef<LoadingDialogComponent> | null = null;

  constructor(private dialog: MatDialog) {}

  show(message: string = 'Loading...', viewContainerRef?: ViewContainerRef): void {
    if (!this.dialogRef) {
      this.dialogRef = this.dialog.open(LoadingDialogComponent, {
        disableClose: true, // Prevent user from closing the dialog manually
        viewContainerRef, // Attach the dialog to the form
        panelClass: 'loading-dialog', // Optional: For styling
        data: { message },
        minWidth: '100px', // Set minimum width
      });
    }
  }

  hide(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}
